import styles from "./index.module.css";
import { useId } from "react";

export type SwitchProps = {
	id?: string;
	value: boolean;
	onChange: (_: boolean) => void;
};

export type LabeledSwitchProps = Omit<SwitchProps, "id"> & {
	label?: React.ReactNode;
	orientation?: "start" | "end";
};

export function Switch({ id, value, onChange }: SwitchProps) {
	const toggleCheck = () => onChange(!value);

	return (
		<span className={styles.switch}>
			<input id={id} type="checkbox" checked={value} onChange={toggleCheck} />
			<span className={styles.slider}></span>
		</span>
	);
}

export function LabeledSwitch({ value, onChange, label, orientation = "start" }: LabeledSwitchProps) {
	const switchId = useId();
	const checkbox = <Switch id={switchId} value={value} onChange={onChange} />;
	return (
		<label className={styles.switchWrapper} htmlFor={switchId}>
			{orientation === "start" && checkbox}
			<span>{label}</span>
			{orientation === "end" && checkbox}
		</label>
	);
}
